// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"48":"fdfa012e","450":"0a4f79b8"}[chunkId] + ".chunk.css";
};